<template>
    <div>
      <v-alert
        :value="!vendor.isApproved"
        type="error"
        icon="new_releases"
        outline
      >
        This organisation has not yet been approved. Click 'Approve' to allow its users to login
        <v-spacer></v-spacer>
        <v-btn color="success" @click="approve">Approve</v-btn>
      </v-alert>
    <v-tabs v-model="activeTab">
      <v-tab @click="didClickOrganisation()">
        Organisation
      </v-tab>
      <v-tab @click="didClickUsers()">
        Users
      </v-tab>
      <v-tab-item>
        <v-toolbar flat>
          <v-toolbar-title>Organisation Details</v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-row>
            <v-col cols="12">
              <p>Name: {{vendor.name}}</p>
              <p>Date Created: {{vendor.dateCreated | formatDate}}</p>
              <p>Date Modified: {{vendor.dateModified | formatDate}}</p>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-toolbar flat>
          <v-toolbar-title>Users</v-toolbar-title>
          <v-toolbar-items>
            <v-btn flat color="primary" dark slot="activator" @click="showNewAccountDialog = true">
              <v-icon dark>add</v-icon>Add User</v-btn>
          </v-toolbar-items>
        </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="users"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.role }}</td>
          <td>{{ props.item.lastSession | formatDate }}</td>
          <td class="justify-center layout px-0">
            <v-btn icon class="mx-0" @click="editAccount(props.item)">
              <v-icon color="blue darken-3">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="confirmDeleteAccount(props.item)">
              <v-icon color="red darken-3">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template slot="no-data">
            This organisation doesn't yet have any user accounts.
            <v-btn color="primary" @click="showNewAccountDialog = true">Add User</v-btn>
        </template>
    </v-data-table>
      </v-tab-item>
    </v-tabs>

    <v-dialog v-model="deleteDialog" max-width="300">
      <v-card>
        <v-card-title class="headline">Delete User</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Are you sure you would like to delete this User?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat="flat" @click.native="deleteItem(false)">
            Cancel
          </v-btn>
          <v-btn color="red darken-1" flat="flat" @click.native="deleteItem(true)">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="editedItem.name"
                        label="Vendor Name"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <vendor-account-new-dialog :show="showNewAccountDialog" :onDismiss="onDismissNewAccountDialog"></vendor-account-new-dialog>
    <vendor-account-edit-dialog :show="showEditAccountDialog" :onDismiss="onDismissEditAccountDialog" :user="editedItem"></vendor-account-edit-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    showNewAccountDialog: false,
    showEditAccountDialog: false,
    activeTab: null,
    dialog: false,
    deleteDialog: false,
    itemToDelete: null,
    headers: [
      { text: 'Name', align: 'left', sortable: true, value: 'name' },
      { text: 'Email', align: 'left', sortable: true, value: 'email' },
      { text: 'Role', align: 'left', sortable: true, value: 'role' },
      { text: 'Last Session', value: 'dateModified', sortable: true },
      { text: 'Actions', align: 'centre', value: 'name', sortable: false }
    ],
    editedIndex: -1,
    editedItem: { name: '', dateModified: '' },
    defaultItem: { name: '', dateModified: '' },
    nameRules: [
      v => !!v || 'Vendor name is required'
    ]
  }),

  created () {
    // Fetch the organisation details from the server
    var id = this.$route.params.id
    this.$store.dispatch('vendors/view', id)
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Vendor' : 'Edit Vendor'
    },
    users () {
      return this.$store.state.vendorAccounts.items
    },
    vendor () {
      return this.$store.state.vendors.selectedItem
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  methods: {
    didClickUsers () {
      // Get the Organisation accounts from the server
      this.$store.dispatch('vendorAccounts/list', this.vendor.id)
    },
    didClickOrganisation () {
      console.log('organisation tab clicked')
    },
    viewAccounts (item) {

    },

    editAccount (item) {
      this.editedIndex = this.users.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.showEditAccountDialog = true
    },

    approve (item) {
      this.$store.dispatch('vendors/approve', this.vendor.id)
    },

    confirmDeleteAccount (item) {
      this.itemToDelete = item
      this.deleteDialog = true
    },

    deleteItem (shouldDelete) {
      if (shouldDelete) {
        this.$store.dispatch('vendorAccounts/delete',
          {
            vendorId: this.vendor.id,
            accountId: this.itemToDelete.id
          })
      }
      this.itemToDelete = null
      this.deleteDialog = false
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {
        this.$store.dispatch('vendors/update', this.editedItem)
      } else {
        this.$store.dispatch('vendors/create', this.editedItem)
      }
      this.close()
    },
    onDismissNewAccountDialog () {
      this.showNewAccountDialog = false
    },
    onDismissEditAccountDialog () {
      this.showEditAccountDialog = false
    }
  }
}
</script>
